/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import PostGroupProvider from 'app/redux/Providers/PostGroupProvider.jsx';
import Loading from 'app/components/common/Loading.jsx';

class PostingGroups extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedGroups: [],
            loading: true
        };

        this.selectPostGroups = this.selectPostGroups.bind(this);
        this.onPostGroupClick = this.onPostGroupClick.bind(this);

    }

    componentDidMount() {

        this.props.getPostGroups();

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.app.loading.POSTGROUP_LIST === true && this.props.app.loading.POSTGROUP_LIST === false) {
            this.setState({
                loading: false
            });
        }

    }

    selectPostGroups(e) {
        e.preventDefault();

        let socials = [];
        this.state.selectedGroups.map((groupId) => {
            let group = this.props.postgroups.find(({id}) => { return groupId === id; });
            if (group) {
                socials = socials.concat(group.group);
            }
        });

        this.props.confirmAction(socials);

    }

    onPostGroupClick(e) {
        let id = parseInt(e.currentTarget.dataset.groupid, 10),
            nextSelectedGroups = [...this.state.selectedGroups];

        if (nextSelectedGroups.indexOf(id) === -1) {
            nextSelectedGroups.push(id);
        } else {
            nextSelectedGroups.splice(nextSelectedGroups.indexOf(id), 1);
        }

        this.setState({
            selectedGroups: nextSelectedGroups
        });

    }

    render() {
        let content = null,
            buttonLabel = "Select Groups";

        if (this.state.loading) {
            content = (
                <Loading/>
            );
        } else if (this.props.app.hasNoData.POSTGROUP_LIST === true) {
            content = (
                <div>
                    <div className="pt-accessory-header">
                        {"It looks you haven't created any posting groups"}
                    </div>
                    <div className="pt-post-group-wrapper">
                        <div className="pt-post-group-empty-state-copy">
                            Posting groups are a great way to organize your socials and quickly apply them when you create a post or feed.
                        </div>
                    </div>
                    <div className="pt-accessory-actions">
                        <div role="button" className="action-cancel" onClick={this.props.cancelAction}>
                            Go Back
                        </div>
                        <button type="button" className="btn-delete action-delete" onClick={() => {
                                this.props.router.navigate("/config/postgroups");
                            }}>
                            Go to posting groups
                        </button>
                    </div>
                </div>
            );
        } else {
            if (this.state.selectedGroups.length === 1) {
                buttonLabel = "Select Group";
            }

            content = (
                <div>
                    <div className="pt-accessory-header">Posting Groups</div>
                    <div className="pt-post-group-wrapper">
                        <ul className="pt-post-group-list">
                        {this.props.postgroups.map((group) => {
                            let selectionIconClass = 'icon ion-android-radio-button-off',
                                selected = this.state.selectedGroups.indexOf(group.id) !== -1;

                            if (selected) {
                                selectionIconClass = 'icon ion-android-checkmark-circle';
                            }

                            return (
                                <li key={group.id} data-groupid={group.id} role="checkbox" aria-checked={selected} aria-label={group.name} onClick={this.onPostGroupClick}>
                                    <div className="group-name">{group.name}</div>
                                    <div className="selection-indicator"><i className={selectionIconClass}></i></div>
                                </li>
                            );

                        })}
                        </ul>
                    </div>
                    <div className="pt-accessory-actions">
                        <div role="button" className="action-cancel" onClick={this.props.cancelAction}>
                            Go Back
                        </div>
                        <button type="button" className="btn-delete action-delete" onClick={this.selectPostGroups}>
                            {buttonLabel}
                        </button>
                    </div>
                </div>
            );
        }

        return content;
    }
}

PostingGroups.displayName = "PostingGroups";

export default PostGroupProvider(PostingGroups);
